import { StyleSheet, css } from 'aphrodite';
import React, { useState, useEffect } from 'react';
import { colorThemes, textStyles } from '../../commonStyles';
import { animated as a } from 'react-spring';
import { useSpring } from '@react-spring/core';
import { useMeasure } from 'react-use';
import { usePreferences, useSFX } from '../../stores';
const Icon = (props) => {
    return (
        // <img
        //     {...props}
        //     className={css(styles.button)}
        //     src={maleHead}
        //     style={{  float: 'left',marginTop:props.hover?'-1vh':'0vh',marginLeft:props.hover?'-.03vw':'0vw'}}
        //     width="2.3vw"
        // />
        <svg
            {...props}
            className={css(styles.button)}
            // style={{ transform:props.hover?'translateY(-50%)':'initial', float: 'left',marginTop:props.hover?'1vh':'0vh',marginLeft:props.hover?'-0.8vw':'0vw' }}
            style={{
                float: 'left',
                marginTop: props.hover ? '-1vh' : '0vh',
                marginLeft: props.hover ? '-.03vw' : '0vw'
            }}
            width="2.3vw"
            viewBox="0 0 28 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 0C13.6318 0 13.3333 0.298467 13.3333 0.666667V3.33333C13.3333 3.70153 13.6318 4 14 4C14.3682 4 14.6667 3.70153 14.6667 3.33333V0.666667C14.6667 0.298467 14.3682 0 14 0ZM4.57293 3.90625C4.4023 3.90625 4.23437 3.97397 4.10417 4.10417C3.84383 4.3645 3.84383 4.7813 4.10417 5.04167L5.9896 6.92708C6.24987 7.18742 6.66673 7.18742 6.92707 6.92708C7.18743 6.66675 7.18743 6.24995 6.92707 5.98958L5.04167 4.10417C4.9115 3.97397 4.7435 3.90625 4.57293 3.90625ZM23.4271 3.90625C23.2565 3.90625 23.0885 3.97397 22.9583 4.10417L21.0729 5.98958C20.8126 6.24995 20.8126 6.66675 21.0729 6.92708C21.3333 7.18742 21.7501 7.18742 22.0104 6.92708L23.8958 5.04167C24.1562 4.7813 24.1562 4.3645 23.8958 4.10417C23.7656 3.97397 23.5977 3.90625 23.4271 3.90625ZM14 6C9.93493 6 6 9.15384 6 13.6146C6 19.4025 10.3333 20.6146 10.3333 24.6667H17.6667C17.6667 20.6146 22 19.4025 22 13.6146C22 9.15384 18.0651 6 14 6ZM11.9479 8.02083C11.9514 8.02081 11.9548 8.02081 11.9583 8.02083C11.9756 8.02016 11.993 8.02016 12.0103 8.02083C12.1664 8.02157 12.3173 8.07705 12.4367 8.17759C12.5561 8.27814 12.6364 8.41738 12.6637 8.57107C12.6909 8.72475 12.6634 8.88313 12.5859 9.01862C12.5084 9.1541 12.3858 9.25811 12.2395 9.3125C10.6151 9.925 9.39443 11.3634 9.08327 13.1146C9.05149 13.2887 8.95188 13.443 8.80634 13.5436C8.66081 13.6442 8.48127 13.6828 8.30722 13.651C8.13317 13.6193 7.97887 13.5197 7.87827 13.3741C7.77766 13.2286 7.73899 13.049 7.77077 12.875C8.16473 10.6579 9.7 8.84989 11.7603 8.07292C11.82 8.04648 11.8832 8.02893 11.9479 8.02083ZM0.666667 13.3333C0.298467 13.3333 0 13.6318 0 14C0 14.3682 0.298467 14.6667 0.666667 14.6667H3.33333C3.70153 14.6667 4 14.3682 4 14C4 13.6318 3.70153 13.3333 3.33333 13.3333H0.666667ZM24.6667 13.3333C24.2985 13.3333 24 13.6318 24 14C24 14.3682 24.2985 14.6667 24.6667 14.6667H27.3333C27.7015 14.6667 28 14.3682 28 14C28 13.6318 27.7015 13.3333 27.3333 13.3333H24.6667ZM10.3333 26V27.3333H17.6667V26H10.3333ZM10.3333 28.6667C10.3333 29.4327 10.9632 30 11.6667 30H16.3333C17.0368 30 17.6667 29.4327 17.6667 28.6667H10.3333ZM12.6667 30.6667C12.6667 31.4053 13.2613 32 14 32C14.7387 32 15.3333 31.4053 15.3333 30.6667H12.6667Z"
                fill="#1D85FE"
            />
        </svg>
    );
};
export const Hover = ({ hover, opacity, hints, links, heading }) => {
    const {
        preferences: { avatar }
    } = usePreferences();
    const { playHint } = useSFX();
    useEffect(() => {
        playHint();
    }, []);
    return hover ? (
        <div>
            <a.div className={css(styles.textContainer)}>
                <Icon hover />
                <a.div style={{ opacity }}>
                    <h1 className={css(textStyles.para18, styles.heading)}>
                        {avatar === 1 ? `Hitesh's ` : `Hema's `} Quick Tips
                    </h1>
                    <p className={css(textStyles.para12, styles.smallText)}>
                        {heading}
                    </p>
                    <ul
                        className={css(textStyles.para14)}
                        style={{ marginLeft: '-2vw', marginTop: '2vh' }}
                    >
                        {hints.split(',').map((hint, i) => (
                            <li style={{ marginTop: '1%' }}>
                                {hint}
                                {links ? (
                                    <a
                                        className={css(styles.links)}
                                        target="_blank"
                                        href={links.split(',')[i]}
                                        style={{
                                            pointerEvents: hover
                                                ? 'auto'
                                                : 'none',
                                            cursor: 'pointer'
                                        }}
                                        rel="noreferrer"
                                    >
                                        {links.split(',')[i]}
                                    </a>
                                ) : null}
                            </li>
                        ))}
                    </ul>
                </a.div>
            </a.div>
        </div>
    ) : (
        <div>
            <Icon />
        </div>
    );
};
export const Hints = (props) => {
    const [hover, set] = useState(false);
    const [show, setShow] = useState(true);
    const [ref, { height, width }] = useMeasure();
    useEffect(() => {
        // console.log(height,width)
    }, [height]);
    useEffect(() => {
        let timeout = setTimeout(() => setShow(false), 5500);
        return () => clearTimeout(timeout);
    }, []);
    const { opacity } = useSpring({
        from: { opacity: 0 },
        opacity: hover || show ? 1 : 0,
        delay: hover || show ? 350 : 0,
        config: { friction: 20 }
    });
    const spring = useSpring({
        width: width,
        height: height,
        delay: !hover && show ? 500 : 0
    });
    return (
        <a.div
        // style={{...props.style}}
        >
            <a.div
                className={css(styles.container)}
                ref={ref}
                style={{
                    opacity: 0,
                    pointerEvents: 'auto',
                    minWidth: hover || show ? '20%' : 'auto'
                }}
                // onMouseEnter={() => set(true)}
                // onMouseLeave={() => set(false)}
            >
                <Hover
                    heading={props.heading}
                    links={props.links}
                    hints={props.hints}
                    hover={hover || show}
                    opacity={opacity}
                />
            </a.div>
            <a.div
                className={css(styles.container)}
                // ref={ref}
                style={{ ...spring, ...props.style, boxSizing: 'content-box' }}
                onMouseEnter={() => set(true)}
                onMouseLeave={() => set(false)}
            >
                <Hover
                    heading={props.heading}
                    links={props.links}
                    hints={props.hints}
                    hover={hover || show}
                    opacity={opacity}
                />
            </a.div>
        </a.div>
    );
};
const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        zIndex: 11000,
        // display:'block',
        // boxSizing: 'border-box',
        maxWidth: '35%',
        boxShadow: '#08A4CF 0px -4px inset',
        // outline: '0.25vh #212121 solid',
        backgroundColor: 'rgba(255,255,255,1)',
        // minWidth:'30%',
        color: 'black',
        right: '3%',
        bottom: '4%',

        borderRadius: '2.7vh',
        padding: '0.8%'
        // backgroundColor: '#E1F3FC',
        // border: '0.22vh solid black',
        // transition:'1000ms'
    },
    textContainer: {
        textAlign: 'left',
        boxSizing: 'border-box',
        padding: '1vh 1vw 0.8vh 1vw'
    },
    smallText: {
        margin: '0vh 0 0 3vw'
    },
    heading: {
        // fontFamily:'Roboto Bold',
        margin: '-0.8% 0% 0% 3vw'
    },
    links: {
        color: colorThemes.blue
    }
});
// const styles = StyleSheet.create({
//     container: {
//         boxSizing: 'border-box',
//         position: 'absolute',
//         minWidth: '40%',
//         color: 'black',
//         // padding:'2% 2% 2% 2%',
//         borderRadius: '5px',
//         backgroundColor: 'white',
//         right: '3%',
//         bottom: '4%',
//         display: 'flex',
//         // maxHeight:'50%',
//         margin: 0,
//         zIndex: 3000,
//         textAlign: 'left',
//         border: '0.22vh solid black',
//         // transitionDuration: '1s',
//         padding: '0.5%'
//     },
//     smolContainer:{
//         boxSizing: 'border-box',
//         position: 'absolute',
//         // minWidth: '40%',
//         color: 'black',
//         // padding:'2% 2% 2% 2%',
//         borderRadius: '5px',
//         backgroundColor: 'white',
//         right: '3%',
//         bottom: '4%',
//         display: 'flex',
//         // maxHeight:'50%',
//         margin: 0,
//         zIndex: 3000,
//         textAlign: 'left',
//         border: '0.22vh solid black',
//         transitionDuration: '1s',
//         padding: '0.5%',
//         // width:'4%'

//     }
// });
